<template>
  <b-dropdown
    class="filter-dropdown"
    variant="outline-dark"
    :toggle-class="`filter-dropdown--toggle ${isDarkMode ? 'dark' : 'light'} rounded-pill`"
    no-caret
  >
    <template #button-content>
      <b-icon icon="sliders"></b-icon>
      Filter
    </template>
    <b-dropdown-form class="filter-dropdown--filter">
      <div
        v-for="filter in filters"
        :key="filter.name"
        class="filter-dropdown--filter-item d-flex align-items-center gap-2"
      >
        <span>{{ `${filter.label}:` }}</span>
        <slot :name="filter.name"></slot>
      </div>
      <div v-if="!noClear">
        <slot name="clear-button">
          <b-button
            variant="outline-danger"
            pill
            rounded
            size="xs"
            class="float-right"
            @click="$emit('clear')"
          >
            {{ clearFilterLabel }}
          </b-button>
        </slot>
      </div>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>
export default {
  name: "FilterDropdown",
  props: {
    isDarkMode: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Array,
      required: true,
    },
    clearFilterLabel: {
      type: String,
      default: "Clear Filter"
    },
    noClear: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="scss">
.filter-dropdown {
  .dropdown-menu {
    left: -20px !important;
    @media (max-width: 767px) {
      left: -4px !important;
    }
  }
  &--toggle {
    font-size: 0.875rem;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: 8px;

    &.light {
      border: 1px solid #667085;
      background: #fff;

      &:hover {
        color: #263238;
      }
      &:active {
        box-shadow: none;
        border: 1px solid #667085;
        background: #fff;
        color: #263238;
      }
      &[aria-expanded=true] {
        box-shadow: none;
        border: 1px solid #667085;
        background: #fff;
        color: #263238;
      }
    }
    &.dark {
      color: #fff;
      background-color: #263238;
      border-color: rgba(255, 255, 255, 0.2) !important;

      &[aria-expanded=true] {
        color: #fff;
        background-color: #263238;
        border-color: rgba(255, 255, 255, 0.2) !important;
      }
    }
  }

  &--filter {
    width: 300px;
    >.b-dropdown-form {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      padding: 0 0.5rem;
    }
    &-item {
      >span {
        width: 80px;
        font-size: 0.75rem;
        text-align: right;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .v-select {
        flex: 1;
      }
    }
  }
}
</style>